import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskCompleteEarlyPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskCompleteEarlyPage;
